import { Accordion, AccordionSummary, ListItem, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Limitations = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel12-content"
                id="panel12-header"
            >
                Limitations
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    There are two particularly important limitations that wine producers must
                    consider when providing information via a QR code:
                </Typography>
                <Styled.OrderedList disablePadding sx={{ marginLeft: "16px" }}>
                    <ListItem disablePadding sx={{ display: "list-item" }}>
                        Marketing
                    </ListItem>
                    <Styled.UnorderedList>
                        <ListItem disablePadding>
                            <ListItemText primary="The electronic label shall exclusively display information relevant to the product and shall not contain any content intended for advertising or marketing purposes." />
                        </ListItem>
                    </Styled.UnorderedList>
                    <ListItem disablePadding sx={{ display: "list-item" }}>
                        Data collection
                    </ListItem>
                    <Styled.UnorderedList>
                        <ListItem disablePadding>
                            <ListItemText primary="Collecting or tracking user data by any electronic means is prohibited." />
                        </ListItem>
                    </Styled.UnorderedList>
                </Styled.OrderedList>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Limitations;
